import { ColorPicker, ColorPickerProps, ColorSwatch, Group, Popover, TextInput } from '@mantine/core';
import { FC, useEffect, useState } from 'react';
import { ColorFormat } from '@mantine/core/lib/ColorPicker/types';
import { ThemeText } from '../ThemeText';

interface Props extends ColorPickerProps {
  color: string;
  label: string;
  onChange(color: string): void;
  format?: ColorFormat;
}

const MantineColorPicker: FC<Props> = ({ color, label, onChange, format = 'rgba', ...rest }) => {
  const [localColor, setLocalColor] = useState(color);

  useEffect(() => {
    if (color !== localColor) {
      setLocalColor(color);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [color]);

  return (
    <Group>
      <Popover>
        <Popover.Target>
          <ColorSwatch
            radius="sm"
            color={color}
            sx={(theme) => ({
              cursor: 'pointer',
              border: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : 'none'}`,
            })}
          />
        </Popover.Target>
        <Popover.Dropdown>
          <ColorPicker
            format={format}
            value={color}
            swatches={[
              '#25262b',
              '#868e96',
              '#fa5252',
              '#e64980',
              '#be4bdb',
              '#7950f2',
              '#4c6ef5',
              '#228be6',
              '#15aabf',
              '#12b886',
              '#40c057',
              '#82c91e',
              '#fab005',
              '#fd7e14',
            ]}
            onChangeEnd={onChange}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...rest}
          />
          <TextInput
            mt="md"
            icon={<ColorSwatch size={16} radius="sm" color={color} />}
            value={localColor}
            onChange={(e) => setLocalColor(e.currentTarget.value)}
            onBlur={(e) => onChange(e.currentTarget.value)}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                onChange(e.currentTarget.value);
              }
            }}
          />
        </Popover.Dropdown>
      </Popover>
      <ThemeText size="xs">{label}</ThemeText>
    </Group>
  );
};

export default MantineColorPicker;
